import React from 'react'
import { useTranslation } from "react-i18next"

export default function SelectionStatus({selection, choose, onTabClick}) {
    const { t } = useTranslation()
    return (
        <div className='my-3 d-flex flex-wrap gap-2 align-items-center justify-content-between'>
            <div className={`d-flex align-items-center ${onTabClick ? 'cursor' : ''}`} onClick={() => {
                if(onTabClick) {
                    onTabClick('initProcess')
                }
            }}>
                <div className='rounded-circle bg-green selection-status me-2'>
                    <img src='/images/check-white.svg' alt='Hecho'/>
                </div>
                {t('selection.initProcess')}
            </div>
            {
                selection?.videoPresentation &&
                <div className={`d-flex align-items-center  ${onTabClick ? 'cursor' : ''}`}  onClick={() => {
                    if(onTabClick) {
                        onTabClick('uploadVideo')
                    }
                }}>
                    <div className={`rounded-circle selection-status me-2 ${choose?.videoPresentation ? 'bg-green' : 'bg-danger'}`}>
                        {
                            choose?.videoPresentation
                            ?
                                <img src='/images/check-white.svg' alt='Hecho'/>
                            :
                                <img src='/images/exclammation-white.svg' alt='Pendiente'/>
                        }
                    </div>
                    {t('selection.uploadVideo')}
                </div>
            }
            <div className={`d-flex align-items-center  ${((selection?.videoPresentation && choose?.videoPresentation) || choose?.schedule[0]?.days?.length > 0) && onTabClick ? 'cursor' : ''}`} onClick={() => {
                if(((selection?.videoPresentation && choose?.videoPresentation) || choose?.schedule[0]?.days?.length > 0) && onTabClick) {
                    onTabClick('interview')
                }
            }}>
                <div className={`text-white rounded-circle selection-status me-2 ${choose.schedule[choose.schedule?.length - 1]?.days?.length === 1 ? 'bg-green' : choose.schedule[choose.schedule?.length - 1]?.days?.length === 3 ? 'bg-danger' : 'bg-secondary'}`}>
                    {
                        choose.schedule?.days?.length === 1
                        ?
                            <img src='/images/check-white.svg' alt='Hecho'/>
                        :
                            choose.schedule?.days?.length === 3
                            ?
                                <img src='/images/exclammation-white.svg' alt='Pendiente'/>
                            :
                                selection?.videoPresentation
                                ?
                                    3
                                :
                                    2
                    }
                </div>
                {t('selection.interview')}
            </div>
            <div className={`d-flex align-items-center ${choose.offerLetter && onTabClick ? 'cursor' : ''}`} onClick={() => {
                if(choose.offerLetter && onTabClick) {
                    onTabClick('offerLetter')
                }
            }}>
                <div className={`text-white rounded-circle selection-status me-2 ${choose.offerLetter ? 'bg-green' : 'bg-secondary'}`}>
                    {
                        choose.candidateOfferLetterStatus === 1 || choose.candidateOfferLetterStatus === "1"
                        ?
                            <img src='/images/check-white.svg' alt='Hecho'/>
                        :
                            selection?.videoPresentation
                            ?
                                4
                            :
                                3
                    }
                </div>
                {t('selection.offerLetter')}
            </div>
            <div className={`d-flex align-items-center ${choose.incorporationDate?.date && onTabClick ? 'cursor' : ''}`} onClick={() => {
                if(choose.incorporationDate?.date && onTabClick) {
                    onTabClick('incorporationDate')
                }
            }}>
                <div className={`text-white rounded-circle selection-status me-2 ${choose.incorporationDate?.date ? 'bg-green' : 'bg-secondary'}`}>
                    {
                        choose.incorporationDate?.date
                        ?
                            <img src='/images/check-white.svg' alt='Hecho'/>
                        :
                            selection?.videoPresentation
                            ?
                                5
                            :
                                4
                    }
                </div>
                {t('selection.schoolIncorporation')}
            </div>
        </div>
    )
}